import React from 'react';
import PropTypes from 'prop-types';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import MenuItem from 'material-ui/MenuItem';
import RenderSelectInputField from 'components/form/InputFields/RenderSelectInputField';
import Row from 'components/list/Filters/layout/Row';
import accessMethodsHelper from 'helpers/accessMethodsHelper';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ButtonWrapper, FormWrapper, Item, Section } from 'components/ui/table/elements';
import { Field, reduxForm, isInvalid } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';
import styled from 'styled-components';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';

const StyledOption = styled.div`
    margin-top: 20px;
`;

const ReservationSessionForm = (props) => {
    const {
        accessPoints,
        accessPointsAccessMethods,
        buttonLabel,
        description,
        handleSubmit,
        invalid,
        onCloseModal,
        onHandleSubmit,
        onSelectAccessPoint,
        submitting,
        translate,
    } = props;

    return (
        <div>
            <div>{description}</div>
            <FormWrapper setMaxWidth={ false }>
                <form onSubmit={ handleSubmit(onHandleSubmit) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    name='access_point'
                                    component={ RenderSelectInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.access_points.fields.access_point') }
                                    floatingLabelFixed={ true }
                                    startingValue={ 0 }
                                >
                                    <MenuItem primaryText={ translate('fields.none') } value={ 0 } />

                                    {
                                        Object.values(accessPoints).map((accessPoint) => {
                                            return (
                                                <MenuItem
                                                    key={ utils.uuid() }
                                                    primaryText={ accessPoint.title }
                                                    value={ accessPoint.id }
                                                    onTouchTap={ () => {
                                                        onSelectAccessPoint(accessPoint.id);
                                                    } }
                                                />
                                            );
                                        })
                                    }
                                </Field>
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    name='access_points_access_method_id'
                                    component={ RenderSelectInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.access_points.fields.access_method') }
                                    startingValue={ 0 }
                                >
                                    <MenuItem primaryText={ translate('fields.none') } value={ 0 } />

                                    {
                                        Object.values(accessPointsAccessMethods).map((accessPointsAccessMethod) => {
                                            return (
                                                <MenuItem
                                                    key={ utils.uuid() }
                                                    primaryText={ accessMethodsHelper.getMethodName(accessPointsAccessMethod.access_method_id) }
                                                    value={ accessPointsAccessMethod.id }
                                                />
                                            );
                                        })
                                    }
                                </Field>
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <StyledOption>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        label={ translate('resources.reservations.session.modal.checkbox') }
                                        type='checkbox'
                                        name='execute_access'
                                    />
                                </StyledOption>
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <StyledOption>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        label={ translate('resources.reservations.session.modal.force') }
                                        type='checkbox'
                                        name='force'
                                    />
                                </StyledOption>
                            </Item>
                        </Row>
                    </Section>
                    <Section>
                        <ButtonWrapper>
                            <RaisedButton
                                label={ translate(`actions.close`) }
                                onTouchTap={ onCloseModal }
                                key='close'
                            />

                            <EnhancedRaisedButton
                                label={ buttonLabel }
                                type='submit'
                                loading={ submitting }
                                disabled={ submitting || invalid }
                                primary
                            />
                        </ButtonWrapper>
                    </Section>
                </form>
            </FormWrapper>
        </div>
    );
};

ReservationSessionForm.propTypes = {
    accessPoints: PropTypes.object,
    accessPointsAccessMethods: PropTypes.object,
    buttonLabel: PropTypes.string.isRequired,
    description: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onHandleSubmit: PropTypes.func.isRequired,
    onSelectAccessPoint: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
        initialValues: { access_points_access_method_id: null, execute_access: true },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    translate,
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            const {
                access_point,
                access_points_access_method_id,
            } = values;

            if ((access_point && access_point !== 0) && (access_points_access_method_id === 0 || !access_points_access_method_id)) {
                errors.access_points_access_method_id = translate('aor.validation.required');
            }

            return errors;
        },
    }),
);

export default enhance(ReservationSessionForm);



// WEBPACK FOOTER //
// ./src/pages/reservations/show/session/ReservationSessionForm.js